if (document.readyState !== "loading") {
  //console.log('document is already ready, just execute code here');
  runOnDOMReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    //console.log('document was not ready, place code here');
    runOnDOMReady();
  });
}
// wait until DOM is ready
function runOnDOMReady() {
  if (document.getElementsByClassName("gsap-image-with-text").length > 0) {
    let gsapBlockRows = gsap.utils.toArray(".gsap-block-row"),
      scrollTween,
      singleDuration = 350,
      totalDuration = singleDuration * gsapBlockRows.length;
    const gsapBlockText = document.querySelector('.gsap-block-row .image-with-text__content');

    gsap.to(".gsap-image-with-text", {
      scrollTrigger: {
        start: "center center",
        pin: ".gsap-image-with-text",
        end: "+=" + `${totalDuration}s`,
        scrub: true,
      },
    });

    gsapBlockRows.forEach((gsapBlockRow, i, arr) => {
      const thisGsapBlockText = gsapBlockRow.querySelector(' .image-with-text__content');
      
      gsap.set(gsapBlockRow, {
        zIndex: (i, gsapBlockRow, gsapBlockRows) => gsapBlockRows.length - i,
      });

      if(!arr[i + 1]) { // on last item
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: gsapBlockRow,
            toggleActions: "play reverse play reverse",
            start: "+=" + `${singleDuration * i}s`,
            end: "+=" + `${singleDuration}s`,
            scrub: true, 
            //markers: true,
            onEnter: () => {
              gsap.to(gsapBlockRow, { autoAlpha: 1 });
  
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 0, 
                autoAlpha: 1
              });
            },
            onEnterBack: () => {
              gsap.to(gsapBlockRow, { autoAlpha: 1 });
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 0, 
                autoAlpha: 1
              });
            },
            onLeaveBack: () => {
              if (i === 0) return;
              gsap.to(gsapBlockRow, { autoAlpha: 0 });
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 100, 
                autoAlpha: 0
              });
            },
          },
        });
      } else {
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: gsapBlockRow,
            toggleActions: "play reverse play reverse",
            start: "+=" + `${singleDuration * i}s`,
            end: "+=" + `${singleDuration}s`,
            scrub: true, 
            //markers: true,
            onEnter: () => {
              gsap.to(gsapBlockRow, { autoAlpha: 1 });
  
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 0, 
                autoAlpha: 1
              });
            },
            onLeave: () => {
              gsap.to(gsapBlockRow, { autoAlpha: 0  });
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: -100,
                autoAlpha: 0
              });
            },
            onEnterBack: () => {
              gsap.to(gsapBlockRow, { autoAlpha: 1 });
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 0, 
                autoAlpha: 1
              });
            },
            onLeaveBack: () => {
              if (i === 0) return;
              gsap.to(gsapBlockRow, { autoAlpha: 0 });
              gsap.to(thisGsapBlockText, 2.25, {
                yPercent: 100, 
                autoAlpha: 0
              });
            },
          },
        });
      }
    });
  }
}
